import React from 'react';

const Header: React.FC = () => (
  <header className="bg-white shadow-sm sticky top-0 z-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-between items-center py-4">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">RX</span>
          </div>
          <span className="text-xl font-bold text-gray-900">Roommaster × Xero</span>
        </div>
        <nav className="hidden md:flex space-x-8">
          <a 
            href="#features" 
            className="text-gray-600 hover:text-gray-900 transition-colors"
            aria-label="View features"
          >
            Features
          </a>
          <a 
            href="#signup" 
            className="text-gray-600 hover:text-gray-900 transition-colors"
            aria-label="Sign up for updates"
          >
            Get Updates
          </a>
        </nav>
      </div>
    </div>
  </header>
);

export default Header;